/**
 * @packageDocumentation
 * @module f1/is
 */

import is_object from './is_object';

export interface IsSet {
  /**
   * Is the value a Set
   *
   * @public
   * @function f1.is.set
   * @example
   *
   * ```ts
   * f1.is.set(new Set()) => true
   * ```
   */
  <V>(v: unknown): v is Set<V>;
}

/**
 * @see IsSet
 */
export default <V>(v: unknown): v is Set<V> => {
  return v && is_object(v) && v.constructor.name === 'Set';
};
